import { Validator } from "../validator"

export enum CompanyNameError {
    BLANK = `invalid_input`,
    INVALIDCHARACTERS = `Please enter your company name without special characters.`,
}
const companyInputLength = 100
// SingPass "Entity Name" data item: letters, digits, space and
// @ / & . - ( ) ' , ; [ ] ~ ! ^ _ * # $ + | { } < > ? \ : =
const REGEX = /^[a-zA-Z0-9 @/&.()',;[\]~!^_*#$+|{}<>?\\:=-]*$/

class CompanyNameValidator implements Validator<string, CompanyNameError> {
    validate(entry: string): CompanyNameError | undefined {
        if (entry === `` || entry.length > companyInputLength) {
            return CompanyNameError.BLANK
        }
        if (!REGEX.test(entry)) {
            return CompanyNameError.INVALIDCHARACTERS
        }
    }
}

export { CompanyNameValidator }
